import { isEqual } from 'lodash';
import * as immutable from 'object-path-immutable';
import camelCase from 'camelcase';
import camelcaseKeys from 'camelcase-keys';

export const defaultEntities = {
  user: {},
  userDetails: {},
  cmsPage: {},
  socialAccounts: {},
  socialPlatformMaster: {},
  socialPlatformAppKeys: {},
  socialPageInfo: {},
  packageInformation: {},
  subscriptionInformation:{},
};

export default function entities(state = defaultEntities, action) {
  if (!action.error && action.payload) {
    const imm = immutable.wrap(state);
      // console.log("PAYLOAD DATA IN ENTITIES", action.payload)
    if (action.payload.data) {
      let rows = action.payload.data;

      if (!Array.isArray(rows)) {
        rows = [rows];
      }

      rows.forEach(row => setRecord(state, imm, row));
    }

    // if (action.payload.included) {
    //   let rows = action.payload.included;

    //   if (!Array.isArray(rows)) {
    //     rows = [rows];
    //   }

    //   rows.forEach(row => setRecord(state, imm, row));
    // }

    return imm.value();
  }

  return state;
}

function setRecord(state, imm, data) {
  if (!data.id) return;
  // console.log("DATA IN ENTITIES",data)

  let row = { ...data, type: data.type? camelCase(data.type) : "" };
  row = camelcaseKeys(row, { deep: true });
  let record = {};
  // console.log("inside entities")
  // console.log("row data>>",row.type)
if(row.type=="userDetails")
{
  // let newData = row.attributes.user;
  // newData.push()
  console.log("row data??",row)
  // record = { ...row.attributes.user, user: row.id,userRole: row.attributes.userRole };
  record = { ...row.attributes.user, user: {id:row.id},userRole: row.attributes.userRole };
}
  else if(row.type=="socialAccounts")
{
  console.log("row data>>>>",row);
  record = { ...row.attributes, socialPlatformMaster: row.attributes.socialPlatform,id: row.id };
}
else{
  record = { ...row.attributes, id: row.id };
}
  
  // console.log("row data",record)
  // const { relationships } = row;

  // if (relationships) {
  //   Object.keys(relationships).forEach((relation) => {
  //     record[relation] = Array.isArray(relationships[relation].data)
  //       ? relationships[relation].data.map(f => ({ ...f, type: camelCase(f.type) }))
  //       : { ...relationships[relation].data };
  //   });
  // }

  if (!state[row.type] || !isEqual(state[row.type][row.id], record)) {
    imm.set([row.type, row.id], record);
  }
}
